var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$q.platform.is.mobile)?_c('div',[_c('ContactView')],1):_c('div',[_c('div',{staticClass:"row justify-center"},[_c('div',{staticClass:"col-3"}),_c('div',{staticClass:"col-6"},[_c('ContactView')],1),_c('div',{staticClass:"col-3"})])])}
var staticRenderFns = []

export { render, staticRenderFns }